import { number, string, mixed, object, array } from 'yup';

import { YUP_ERRORS_MESSAGES } from '@shared/constants';
import { getRewardValueValidationSchema } from '@shared/utils';

import { UserRewardType, UserRole } from 'v2/constants';

export const dailyRewardValidationSchema = object().shape({
  day: number().required(YUP_ERRORS_MESSAGES.REQUIRED),
  description: string().required(YUP_ERRORS_MESSAGES.REQUIRED),
  rewards: array().of(
    object().shape({
      type: mixed().oneOf(Object.values(UserRewardType)).required(YUP_ERRORS_MESSAGES.REQUIRED),
      value: getRewardValueValidationSchema(),
    })
  ),
  allowedUserRoles: array()
    .of(mixed().oneOf(Object.values(UserRole)).required(YUP_ERRORS_MESSAGES.REQUIRED))
    .min(1, YUP_ERRORS_MESSAGES.ROLES),
});
